/**
 * Mențiuni de presă REALE — sursa pentru PressBanner de pe landing.
 *
 * REGULĂ: se listează DOAR articole publicate și verificabile (link live).
 * Bannerul nu se afișează deloc cât timp lista e goală, deci poate fi
 * deployat înainte de publicarea studiului fără să afirme nimic fals.
 *
 * În ziua publicării: adaugă intrarea și bannerul apare automat.
 * Format: { name: 'Ziarul Financiar', url: 'https://www.zf.ro/...' }
 */
export const PRESS_MENTIONS = [];
